import type { PalletState } from '@wms/shared';

const PHOTO_EDITABLE_STATES: ReadonlySet<PalletState> = new Set([
  'ARRIVED',
  'PARTIALLY_DISPATCHED',
  'DAMAGED',
]);

/** Photo evidence editing is independent from whether pallet contents can be unpacked. */
export function canEditPalletPhotos(state: PalletState): boolean {
  return PHOTO_EDITABLE_STATES.has(state);
}
